// @flow
import { type Services as PromoServices } from 'api/xws/promotions/promotionsWs';

type Services = {
  id: number,
  price: number,
  promotion?: boolean,
  discountedPrice?: number
};

type MenuType = {
  services: Array<Services>,
  totalPrice: number,
  discountedPrice?: number,
  promotion?: boolean
};

export const applyPromotionToService = (
  promoServices: Array<PromoServices>,
  servicesArray: Array<Services>
): Array<Services> => {
  return promoServices
    ? servicesArray.map(service => {
        const promotion = promoServices.find(
          promoService => promoService.serviceId === service.id
        );
        if (promotion) {
          const { discountAmount, discountType } = promotion;
          let discountedPrice;
          if (discountType === 'amount') {
            discountedPrice = Math.max(service.price - discountAmount);
          } else if (discountType === 'percent') {
            discountedPrice = (service.price * (100 - discountAmount)) / 100;
          } else {
            discountedPrice = service.price;
          }
          return {
            ...service,
            promotion: true,
            discountedPrice
          };
        } else {
          return service;
        }
      })
    : servicesArray;
};

export const applyPromotionToPackage = (
  promoServices: Array<PromoServices>,
  menuType: MenuType
): MenuType => {
  const servicesWithPromo = applyPromotionToService(
    promoServices,
    menuType.services
  );
  let discountedTotalPrice = menuType.totalPrice;
  let atLeastOnePromo = false;
  servicesWithPromo.forEach(service => {
    if (service.promotion) {
      atLeastOnePromo = true;
      const { discountedPrice, price } = service;
      discountedTotalPrice -= price - (discountedPrice || 0);
    }
  });
  return {
    ...menuType,
    services: servicesWithPromo,
    promotion: atLeastOnePromo,
    discountedPrice: Math.max(discountedTotalPrice, 0)
  };
};

export const EPSILON = Number.EPSILON || 2.220446049250313e-16;

export const isDiscountValid = (
  price: number,
  discountedPrice: number
): boolean => Math.abs(price - discountedPrice) > EPSILON;



// WEBPACK FOOTER //
// ./src/utils/promotions.js